<template>
	<div class="flex flex-col items-center justify-center w-full h-full">
		<h1>404 - Página não encontrada</h1>
		<p>A página que você está procurando não existe.</p>
	</div>
</template>
